<template>
  <v-container v-if="this.displayCountdown" class="countdown-banner" fluid>
    <v-row class="green pa-2">
      <v-col class="ma-0 pa-0 text-center">
        <p id="demo" class="white--text ma-0"></p>
        <!-- <p>{{ displayCountdown }}</p> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'Countdown',
  data() {
    return {
      countdownDate: new Date("Jun 15, 2024 08:00:00").getTime(),
      displayCountdown: false,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      distance: 0,
    }
  },
  mounted() {
    // this.displayCountdown = false
    if(process.browser) {
      window.document.getElementById("demo").innerHTML = `
              <span class=font-weight-bold>00</span>d
              <span class=font-weight-bold>00</span>h
              <span class=font-weight-bold>00</span>m
              <span class=font-weight-bold>00</span>s
            `;
    }

    this.count(this.countdownDate)
  },
  methods: {
    count(countFrom) {
      var x = setInterval(function() {
        // Get today's date and time
        var now = new Date().getTime()
        
        // Find the distance between now and the count down date
        var distance = countFrom - now
        this.distance = distance
        
        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, "0")
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, "0")
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, "0")
        const seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, "0")

        
      // console.log(this.distance);
      // this.displayCountdown = false
      // console.log(this.displayCountdown);

        // If the count down is finished, write some text
        if (distance < 0) {
          this.displayCountdown = false
          // console.log(this.displayCountdown)
          clearInterval(x)
          console.log('é menor')
        } else {
          // Display the result in the element with id="demo"
          // console.log(process.browser);
          if(process.browser) {
            window.document.getElementById("demo").innerHTML = `
              <span class=font-weight-bold>${days}</span>d 
              <span class=font-weight-bold>${hours}</span>h 
              <span class=font-weight-bold>${minutes}</span>m 
              <span class=font-weight-bold>${seconds}</span>s
            `
          }
        }
      }, 1000);
      
      // this.displayCountdown = false
      // console.log(this.displayCountdown);
    }
  },
}

</script>

<style>
.countdown-banner {
  z-index: 99;
}
p#demo {
  font-variant-numeric: slashed-zero !important;
}
#demo span {
  font-family: monospace;
  font-size: 2rem;
  margin-left: 20px;
}

</style>